<template>
  <div class="Title">
    <img
      @click="toWeb()"
      class="title_logo"
      src="../../assets//images/CwLogo.svg"
      alt=""
    />
    <div class="title_icons">
      <DateTime v-if="!mobileFlag" />
      <LangSelect @onChange="handleLangChange" />
      <div class="menu_icon" @click="goHelp()" v-if="!mobileFlag">
        <img src="../../assets/images/HelpIcon.svg" alt="" />
        {{ $t("Menu_Help") }}
      </div>
      <div class="menu_icon" @click="goMessage()" v-if="!mobileFlag">
        <img src="../../assets/images/MessageIcon.svg" alt="" />
        {{ $t("Menu_Message") }}
      </div>
      <div class="menu_icon" @click="personClick()" ref="personIcon">
        <img src="../../assets/images/PersonIcon.svg" alt="" />
      </div>
      <div
        class="menu_icon"
        ref="personIcon"
        v-if="mobileFlag"
        @click="menuClick()"
      >
        <img src="../../assets/images/MobileMenu.svg" alt="" />
      </div>
    </div>
    <div class="personCard" v-show="isPerson" ref="perosonCard">
      <img src="../../assets/images/PersonImage.svg" alt="" />
      <p class="personName">
        {{ userInfo.email }}
      </p>
      <div class="personReset" @click="isPopupVisible = true">
        <div class="personReset_left">
          <img src="../../assets/images/PersonLock.svg" alt="" />
          <span>{{ $t("Common_LoginPassword") }}</span>
        </div>
        <div class="personReset_right">
          <span>{{ $t("Common_Reset") }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <p class="logout" @click="logout()">{{ $t("Common_Logout") }}</p>
    </div>
    <el-dialog
      class="popupMoudule resetPassword"
      width="324px"
      :visible.sync="isPopupVisible"
      center
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div slot="title">
        <img src="../../assets/images/ResetPasswordIcon.svg" alt="" />
        <p class="popupMouduleTitle">{{ $t("SettingPassword_Title") }}</p>
      </div>
      <el-form
        class="forgetForm"
        ref="changeForm"
        :rules="rules"
        label-position="top"
        label-width="80px"
        :model="changeForm"
      >
        <el-form-item :label="$t('Common_Password')" prop="password">
          <el-input
            v-model="changeForm.password"
            autocomplete="off"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Common_ConfirmPassword')" prop="confirm">
          <el-input
            v-model="changeForm.confirm"
            autocomplete="off"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="btnReset">
        <el-button class="cancelGray" type="primary" @click="cancelPassword()">
          {{ $t("Common_Cancel") }}
        </el-button>
        <el-button
          class="confirmBlue"
          type="primary"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="forget()"
        >
          {{ $t("Common_Confirm") }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="resetPassword"
      width="324px"
      :visible.sync="isPopupVisibleTips"
      :show-close="false"
      center
      :close-on-click-modal="false"
    >
      <div slot="title">
        <img src="../../assets/images/NotifySuccess.svg" alt="" />
        <p class="popupMouduleTitle">{{ $t("Common_Success") }}</p>
        <p class="popupMouduleContent">{{ $t("SettingPassword_ResetSuccessContent") }}</p>
      </div>

      <span slot="footer" class="btnOne">
        <el-button
          type="primary"
          class="confirmBlue"
          @click="(isPopupVisibleTips = false), (isPopupVisible = false)"
        >
          {{ $t("Common_Confirm") }}
        </el-button>
      </span>
    </el-dialog>
    <div v-if="isMenu" class="mask" @click="isMenu = false"></div>
    <transition name="fade">
      <Menu id="menuCard" v-show="isMenu" />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Menu from "@/components/common/Menu.vue";
import Bus from "../../plugins/bus";
import LangSelect from "@/components/common/LangSelect.vue";
import DateTime from "@/components/common/DateTime.vue";

export default {
  name: "Title",
  components: {
    Menu,
    LangSelect,
    DateTime,
  },
  computed: {
    ...mapState(["userInfo", "mobileFlag", "lang"]),
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("Common_PasswordNotNull")));
      } else {
        var pwdRegex = new RegExp(
          "(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}"
        );
        if (!pwdRegex.test(value)) {
          callback(new Error(this.$t("SettingPassword_MatchMessage")));
        } else if (this.changeForm.confirm !== "") {
          this.$refs.changeForm.validateField("confirm");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("Common_ConfirmPasswordNotNull")));
      } else if (value !== this.changeForm.password) {
        callback(new Error(this.$t("Common_ConfirmPasswordNotcorrect")));
      } else {
        callback();
      }
    };
    return {
      languageTxt: "",
      isPerson: false,
      isPopupVisible: false,
      changeForm: {
        password: "",
        confirm: "",
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        confirm: [{ validator: validatePass2, trigger: "blur" }],
      },
      isPopupVisibleTips: false,
      fullscreenLoading: false,
      isMenu: false,
    };
  },
  mounted() {
    Bus.$on("isMobileMenu", (myMsg) => {
      this.isMenu = myMsg;
    });
  },
  created() {
    this.languageTxt = this.lang;
    this.screenClick();
  },
  methods: {
    handleLangChange() {
      Bus.$emit("isLanguage", true);
      location.reload();
    },
    goHelp() {
      this.$router.push({ path: "/HelpCenter" });
    },
    goMessage() {
      this.$router.push({ path: "/MyMessage" });
    },
    screenClick() {
      document.addEventListener("click", (e) => {
        if (this.$refs.perosonCard) {
          let self = this.$refs.perosonCard.contains(e.target);
          let seft = this.$refs.personIcon.contains(e.target);
          if (!self && !seft) {
            this.isPerson = false;
          }
        }
      });
    },
    logout() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push({ path: "/Login" });
    },
    forget() {
      this.$refs.changeForm.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.changeForm.email = this.userInfo.email;
          let params = {
            confirm: this.Rsa.encrypt(this.changeForm.confirm.trim()),
            email: this.userInfo.email,
            password: this.Rsa.encrypt(this.changeForm.password.trim()),
          };
          this.$axios
            .post("/Api/Login/UpdatePassword", params)
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.changeForm.password = "";
                this.changeForm.confirm = "";
                this.isPopupVisibleTips = true;
                this.$router.push({ path: "/Login" });
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result
                });
                
              }
            })
            .finally(() => {
              this.fullscreenLoading = false;            
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    personClick() {
      if (!this.mobileFlag) {
        this.isPerson = !this.isPerson;
      } else {
        this.$router.push({ path: "/MyPerson" });
        this.isMenu = false;
        Bus.$emit("isMask", this.isMenu);
      }
    },
    menuClick() {
      this.isMenu = !this.isMenu;
      Bus.$emit("isMask", this.isMenu);
    },
    cancelPassword() {
      this.$refs.changeForm.resetFields();
      this.isPopupVisible = false;
    },
    toWeb() {
      window.open("https://www.copy-wealth.com");
    },
  },
};
</script>
<style lang="less" scoped>
.Title {
  width: 100%;
  height: 60px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .title_logo {
    padding-left: 40px;
    cursor: pointer;
  }
  .title_icons {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-right: 40px;
    gap: 40px;

    .menu_icon {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #0b205d;
      font-family: "PingFangSC-Medium";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      gap: 6px;
      cursor: pointer;

      img {
        width: 22px;
        height: 22px;
      }
    }
  }
  .personCard {
    position: absolute;
    top: 80px;
    right: 40px;
    padding: 24px 10px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 99;
    .personName {
      color: #0b205d;
      font-family: "PingFangSC-Medium";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin: 5px 0 20px 0;
    }
    .personReset {
      min-width: calc(235px - 20px);
      border-radius: 4px;
      background: #f8f8f8;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 9px 10px;
      align-items: center;
      cursor: pointer;
      .personReset_left {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #0b205d;
        font-family: "PingFangSC-Medium";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        img {
          margin-right: 6px;
        }
      }
      .personReset_right {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #0b205d;
        font-family: "PingFangSC-Regular";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        i {
          margin-left: 6px;
        }
      }
    }
    .logout {
      margin: 20px 0 0 0;
      color: #0b205d;
      font-family: "PingFangSC-Regular";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      cursor: pointer;
    }
  }
}
.resetPassword {
  .popupMouduleTitle {
    color: #333;
    text-align: center;
    font-family: "PingFangSC-Medium";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 20px auto;
  }
  .btnReset {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
.popupMouduleTitle {
  color: #333;
  text-align: center;
  font-family: "PingFangSC-Semibold";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.popupMouduleContent {
  color: #333;
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 20px auto;
}
.cancelGray,
.confirmBlue {
  border-radius: 4px;
  background: #e5e5e5;
  color: #333;
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 0;
  padding: 10px 30px;
}
.confirmBlue {
  background: #4d71ff;
  color: #fff;
}

.pageHeader {
  gap: 6px;

  img {
    width: 22px;
    height: 22px;
    color: red;
  }
}

.title_icons ::v-deep .langSelectWrapper {
  gap: 6px;
}

.title_icons ::v-deep .langIcon {
  width: 22px;
  height: 22px;
  color: red;
}

@media screen and (max-width: 767px) {
  .Title {
    min-height: 0;
    height: 42px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .title_logo {
      margin-left: 16px;
      height: 20px;
      min-width: 110px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title_icons {
      margin-right: 16px;
      gap: 20px;

      .menu_icon {
        margin-left: 0;
        img {
          width: 20px;
          height: 20px;
          margin-right: 0;
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
  .mask {
    position: fixed;
    opacity: 0.7;
    background: #fff;
    width: 100%;
    height: calc(100% - 46px);
    top: 46px;
  }

  .title_icons ::v-deep .langSelectWrapper {
    margin-right: 0;
  }
}
</style>
